import React from 'react';
import { ResourceHistogram } from '@bryntum/schedulerpro';
import { createWidget, shouldComponentUpdate, processWidgetContent } from './WrapperHelper.js';
export class BryntumResourceHistogram extends React.Component {
    constructor() {
        super(...arguments);
        this.processWidgetContent = processWidgetContent;
        this.portalContainerClass = 'b-react-portal-container';
        this.state = {
            portals: new Map(),
            generation: 0
        };
        this.projectStores = false;
        this.dataStores = {
            'resourceTimeRangeStore': 'resourceTimeRanges',
            'timeRangeStore': 'timeRanges'
        };
    }
    componentDidMount() {
        this.instance = createWidget(this);
    }
    componentWillUnmount() {
        var _a, _b;
        (_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }
    render() {
        const className = `b-react-${BryntumResourceHistogram.instanceClass.$name.toLowerCase()}-container`;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: className, ref: (element) => (this.element = element) }, Array.from(this.state.portals).map((item) => item[1])),
            React.createElement("div", { ref: el => (this.portalsCache = el), className: "b-react-portals-cache", style: { display: 'none' } })));
    }
}
BryntumResourceHistogram.instanceClass = ResourceHistogram;
BryntumResourceHistogram.instanceName = 'ResourceHistogram';
BryntumResourceHistogram.isView = true;
BryntumResourceHistogram.featureNames = [
    'cellCopyPasteFeature',
    'cellEditFeature',
    'cellMenuFeature',
    'cellTooltipFeature',
    'columnAutoWidthFeature',
    'columnDragToolbarFeature',
    'columnLinesFeature',
    'columnPickerFeature',
    'columnRenameFeature',
    'columnReorderFeature',
    'columnResizeFeature',
    'excelExporterFeature',
    'fileDropFeature',
    'fillHandleFeature',
    'filterFeature',
    'filterBarFeature',
    'groupFeature',
    'groupSummaryFeature',
    'headerMenuFeature',
    'mergeCellsFeature',
    'multipageFeature',
    'multipageverticalFeature',
    'pdfExportFeature',
    'quickFindFeature',
    'regionResizeFeature',
    'rowCopyPasteFeature',
    'rowExpanderFeature',
    'rowReorderFeature',
    'scheduleTooltipFeature',
    'searchFeature',
    'singlepageFeature',
    'sortFeature',
    'splitFeature',
    'stickyCellsFeature',
    'stripeFeature',
    'summaryFeature',
    'treeFeature',
    'treeGroupFeature'
];
BryntumResourceHistogram.configNames = [
    'adopt',
    'aggregateDataEntry',
    'aggregateHistogramDataForGroups',
    'align',
    'allowOver',
    'anchor',
    'anchorToTarget',
    'animateRemovingRows',
    'ariaDescription',
    'ariaLabel',
    'autoAdjustTimeAxis',
    'autoClose',
    'autoHeight',
    'autoShow',
    'autoUpdateRecord',
    'barTextEffortUnit',
    'barTipEffortUnit',
    'barTooltipTemplate',
    'bbar',
    'bodyCls',
    'bubbleEvents',
    'bufferCoef',
    'bufferThreshold',
    'callOnFunctions',
    'centered',
    'closable',
    'closeAction',
    'collapsed',
    'collapsible',
    'columns',
    'config',
    'constrainTo',
    'contentElementCls',
    'contextMenuTriggerEvent',
    'crudManagerClass',
    'dataModelField',
    'defaultBindProperty',
    'defaultFocus',
    'defaultRegion',
    'defaultResourceImageName',
    'defaults',
    'destroyStore',
    'destroyStores',
    'disableGridRowModelWarning',
    'dismissDelay',
    'dock',
    'draggable',
    'durationDisplayPrecision',
    'effortFormat',
    'effortUnit',
    'enableRecurringEvents',
    'enableSticky',
    'enableTextSelection',
    'endParamName',
    'features',
    'fillLastColumn',
    'fixedRowHeight',
    'floating',
    'focusOnToFront',
    'footer',
    'forElement',
    'forSelector',
    'fullRowRefresh',
    'getBarText',
    'getBarTip',
    'getDataEntryForAggregating',
    'getHtml',
    'getOutlineClass',
    'getRecordData',
    'getRectClass',
    'getRowHeight',
    'hardRefreshOnTimeAxisReconfigure',
    'header',
    'hideAnimation',
    'hideDelay',
    'hideHorizontalScrollbar',
    'hideOnDelegateChange',
    'hideWhenEmpty',
    'histogramWidgetClass',
    'hoverDelay',
    'htmlCls',
    'ignoreDomEventsWhileScrolling',
    'ignoreParentReadOnly',
    'includeInactiveEvents',
    'infiniteScroll',
    'initAggregatedDataEntry',
    'itemCls',
    'keyMap',
    'lazyItems',
    'listeners',
    'loadingMsg',
    'loadMask',
    'loadMaskDefaults',
    'loadMaskError',
    'localeClass',
    'localizable',
    'localizableProperties',
    'managedEventSizing',
    'maskDefaults',
    'masked',
    'maximizable',
    'maximized',
    'modal',
    'monitorResize',
    'mouseOffsetX',
    'mouseOffsetY',
    'namedItems',
    'owner',
    'partner',
    'passStartEndParameters',
    'plugins',
    'positioned',
    'preserveFocusOnDatasetChange',
    'preserveScrollOnDatasetChange',
    'preventTooltipOnTouch',
    'relayStoreEvents',
    'resizeToFitIncludesHeader',
    'resourceColumns',
    'resourceImageExtension',
    'resourceImagePath',
    'responsiveLevels',
    'ripple',
    'rootElement',
    'scaleColumn',
    'scrollAction',
    'scrollerClass',
    'scrollManager',
    'selectionMode',
    'series',
    'showAnimation',
    'showBarText',
    'showBarTip',
    'showDirty',
    'showEffortUnit',
    'showMaxEffort',
    'showOnClick',
    'showOnHover',
    'showTooltipWhenDisabled',
    'snapRelativeToEventStartDate',
    'startParamName',
    'stateful',
    'statefulEvents',
    'stateId',
    'stateProvider',
    'stickyHeaders',
    'strips',
    'subGridConfigs',
    'suppressFit',
    'syncMask',
    'tab',
    'tag',
    'tbar',
    'textAlign',
    'textContent',
    'timeAxis',
    'timeAxisColumn',
    'trackMouse',
    'trapFocus',
    'ui',
    'visibleZoomFactor',
    'weekStartDay',
    'weight',
    'zoomKeepsOriginalTimespan',
    'zoomOnMouseWheel',
    'zoomOnTimeAxisDoubleClick'
];
BryntumResourceHistogram.propertyConfigNames = [
    'alignSelf',
    'appendTo',
    'barMargin',
    'cls',
    'columnLines',
    'content',
    'crudManager',
    'data',
    'dataset',
    'disabled',
    'displayDateFormat',
    'emptyText',
    'enableEventAnimations',
    'enableUndoRedoKeys',
    'endDate',
    'eventColor',
    'eventStyle',
    'extraData',
    'fillTicks',
    'flex',
    'forceFit',
    'height',
    'hidden',
    'hideFooters',
    'hideHeaders',
    'histogramWidget',
    'html',
    'id',
    'insertBefore',
    'insertFirst',
    'items',
    'layout',
    'layoutStyle',
    'longPressTime',
    'margin',
    'maxHeight',
    'maximizeOnMobile',
    'maxWidth',
    'maxZoomLevel',
    'minHeight',
    'minWidth',
    'minZoomLevel',
    'onBeforeAssignmentDelete',
    'onBeforeCancelCellEdit',
    'onBeforeCellDelete',
    'onBeforeCellEditStart',
    'onBeforeClose',
    'onBeforeColumnDragStart',
    'onBeforeColumnDropFinalize',
    'onBeforeCopy',
    'onBeforeDestroy',
    'onBeforeEventDelete',
    'onBeforeFinishCellEdit',
    'onBeforeHide',
    'onBeforeHistogramDataCacheSet',
    'onBeforePaste',
    'onBeforePdfExport',
    'onBeforePresetChange',
    'onBeforeRenderHistogramRow',
    'onBeforeRenderRecordHistogram',
    'onBeforeRenderRow',
    'onBeforeRenderRows',
    'onBeforeSelectionChange',
    'onBeforeSetRecord',
    'onBeforeShow',
    'onBeforeToggleGroup',
    'onBeforeToggleNode',
    'onCancelCellEdit',
    'onCatchAll',
    'onCellClick',
    'onCellContextMenu',
    'onCellDblClick',
    'onCellMenuBeforeShow',
    'onCellMenuItem',
    'onCellMenuShow',
    'onCellMenuToggleItem',
    'onCellMouseOut',
    'onCellMouseOver',
    'onCollapseNode',
    'onColumnDrag',
    'onColumnDragStart',
    'onColumnDrop',
    'onContextMenuItem',
    'onContextMenuToggleItem',
    'onCopy',
    'onDataChange',
    'onDateRangeChange',
    'onDestroy',
    'onDragSelecting',
    'onExpandNode',
    'onFileDrop',
    'onFinishCellEdit',
    'onFocusIn',
    'onFocusOut',
    'onGenerateScalePoints',
    'onGridRowAbort',
    'onGridRowBeforeDragStart',
    'onGridRowBeforeDropFinalize',
    'onGridRowDrag',
    'onGridRowDragStart',
    'onGridRowDrop',
    'onHeaderMenuBeforeShow',
    'onHeaderMenuItem',
    'onHeaderMenuShow',
    'onHeaderMenuToggleItem',
    'onHide',
    'onHistogramDataCacheSet',
    'onMouseOut',
    'onMouseOver',
    'onPaint',
    'onPaste',
    'onPdfExport',
    'onPointerOver',
    'onPresetChange',
    'onReadOnly',
    'onRecompose',
    'onRenderRow',
    'onRenderRows',
    'onResize',
    'onResponsive',
    'onScroll',
    'onSelectionChange',
    'onSelectionModeChange',
    'onShow',
    'onSplit',
    'onSplitterCollapseClick',
    'onSplitterDragEnd',
    'onSplitterDragStart',
    'onStartCellEdit',
    'onSubGridCollapse',
    'onSubGridExpand',
    'onTimeAxisChange',
    'onTimeAxisHeaderClick',
    'onTimeAxisHeaderContextMenu',
    'onTimeAxisHeaderDblClick',
    'onTimelineContextChange',
    'onTimelineViewportResize',
    'onToggleGroup',
    'onToggleNode',
    'onToolClick',
    'onUnsplit',
    'onVisibleDateRangeChange',
    'presets',
    'project',
    'readOnly',
    'record',
    'resourceMargin',
    'resourceTimeRanges',
    'resourceTimeRangeStore',
    'rowHeight',
    'scrollable',
    'snap',
    'startDate',
    'store',
    'strictRecordMapping',
    'tickSize',
    'timeRanges',
    'timeRangeStore',
    'timeZone',
    'title',
    'tools',
    'tooltip',
    'transitionDuration',
    'updateTimelineContextOnScroll',
    'viewPreset',
    'visibleDate',
    'width',
    'workingTime',
    'x',
    'y'
];
BryntumResourceHistogram.propertyNames = [
    'anchorSize',
    'eventColors',
    'eventStyles',
    'isEngineReady',
    'isSettingValues',
    'isValid',
    'scrollLeft',
    'scrollTop',
    'scrollX',
    'selectedCell',
    'selectedCells',
    'selectedRecord',
    'selectedRecords',
    'selectedRows',
    'state',
    'timeResolution',
    'type',
    'values',
    'zoomLevel'
];
//# sourceMappingURL=BryntumResourceHistogram.js.map